module.exports = __webpack_public_path__ + "img/chargingpoint-definitive.84056eec.png";